import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import Notify from '@/components/Notification';
import { userService } from '../../services/userService';

export const useUpdateContactInfo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: payload =>
      userService.contactInfo(payload).then(response => {
        const { status, data } = response;

        if (status === 200) {
          queryClient.setQueryData([QUERY_KEYS.user.profile], () => data);
          Notify.success({ text: 'Contact information updated successfully' });
          return { data, success: true };
        }

        if (status === 422 && data.errors === 'company_already_registered') {
          Notify.error({ text: data.message });
          return {
            data,
            success: false,
            errors: { company_name: data.message },
          };
        }

        Notify.error({ text: 'Could not update contact information', status });
        return null
      }),
  });
};
